// Webpack 5 detects the `new SharedWorker(new URL(..., import.meta.url))` pattern
// and bundles the worker as a separate asset. The full expression must be in one
// statement for static analysis to work.
//
// This file is mocked in jest via moduleNameMapper (ts-jest can't parse import.meta.url).
export function createPopoutWorker(): SharedWorker {
  return new SharedWorker(
    new URL("./popoutWorker.ts", import.meta.url),
    { name: "popout-coordinator" }
  );
}
